import { ParamIds, Places } from '../../../Constants'
import BorderoKeys from '../bordero.keys'
import { ShowResultadoDetalhado } from '../bordero.types'

const resultadoDetalhadoShowKey = 'rdsk_k'

export class ResultadoDetalhadoAnaliseKeys extends BorderoKeys {
    get place() {
        return Places.resultadoDetalhadoAnalise
    }

    get borderoId() {
        return this._intent.getParameterAsNumber(ParamIds.borderoFormId)
    }

    set borderoId(value: number | undefined) {
        this._intent.setParameter(ParamIds.borderoFormId, value)
    }

    get resultadoShowOrigem() {
        return this._intent.getParameterAsString(ParamIds.resultadoShowOrigem)
    }

    set resultadoShowOrigem(value: string | undefined) {
        this._intent.setParameter(ParamIds.resultadoShowOrigem, value)
    }

    get resultadoShowIdOrigem() {
        return this._intent.getParameterAsNumber(ParamIds.resultadoShowIdOrigem)
    }

    set resultadoShowIdOrigem(value: number | undefined) {
        this._intent.setParameter(ParamIds.resultadoShowIdOrigem, value)
    }

    get resultadoShowIdSacado() {
        return this._intent.getParameterAsNumber(ParamIds.resultadoShowIdSacado)
    }

    set resultadoShowIdSacado(value: number | undefined) {
        this._intent.setParameter(ParamIds.resultadoShowIdSacado, value)
    }

    get resultadoDetalhadoShow() {
        return this._intent.attributes.get(resultadoDetalhadoShowKey) as ShowResultadoDetalhado
    }

    set resultadoDetalhadoShow(value: ShowResultadoDetalhado | undefined) {
        this._intent.attributes.set(resultadoDetalhadoShowKey, value)
    }
}
